<i18n locale="en">
{
  "title": "Campaign cannot be sent"
}
</i18n>

<template>
  <OwnDialogHeading :title="t('title')" />
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnDialogHeading } from '@/ui/OwnDialog'

const { t } = useI18n()
</script>
